import { useContext, useMemo } from "react";

import { hasElements, hasNoElements } from "Utils/Array";
import { IOmikronResult } from "Model/Omikron/IOmikronResult";
import { isNullOrWhiteSpace } from "Utils/String";
import { useProjectItem } from "../../Hooks/UseProjectItem";
import { ProjectItemContext } from "../../ProjectItemContext/ProjectItemContext";

export function useResults(results: IOmikronResult[][]): IOmikronResult[] {
  const { projectId, projectItemId } = useContext(ProjectItemContext);
  const { projectItem } = useProjectItem(projectId, projectItemId);

  const omikronResults = useMemo(
    () => results.find((result) => {
      if (hasNoElements(result) || isNullOrWhiteSpace(projectItemId)) {
        return false;
      }

      return result[0][`@id`] === projectItemId;
    }),
    [projectItemId, results]
  );

  if (projectItem == null) {
    return [];
  }

  return [
    {
      ...projectItem,
      "@resultId": projectItemId,
      "@isOrigin": true
    },
    ...(hasElements(omikronResults) ? omikronResults : [])
  ];
}
